import Immutable from 'seamless-immutable';
import { createReducer, completeState, completeReducer } from 'redux-recompose';

import { actions } from './actions';
import { TARGETS } from './constants';

const initialState = {
  [TARGETS.UPLOAD_IMAGE]: null,
  [TARGETS.DOWNLOAD_CSV]: null,
  [TARGETS.IMAGE_URL]: null
};

const completedState = completeState(initialState);

const reducerDescription = {
  primaryActions: [actions.UPLOAD_IMAGE, actions.DOWNLOAD_CSV, actions.GET_IMAGE_URL]
};

const reducer = createReducer(new Immutable(completedState), completeReducer(reducerDescription));

export default reducer;
